/**
 * Rerurns randomish 12-symbol hex hash
 */
module.exports = function randomHash() {
  return Math.random()
    .toString(16)
    .substr(-12);
};
